import React, { useState, useEffect } from "react";
import { useStyles } from "./modalContent";

const ReusableRoleModal = ({
  isOpen,
  onClose,
  mode,
  providerData,
  roles,
  onSubmit,
  onDelete,
}) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    role_id: providerData?.id || "",
  });
  const [error, setError] = useState(null);

  // Update formData when providerData changes
  useEffect(() => {
    setFormData({
      name: providerData?.name || "",
      role_id: providerData?.id || "",
    });
  }, [providerData]);

  const handleChange = (e) => {
    const { value } = e.target;
    const selectedRole = roles.find((role) => role.id === value);
    setFormData({
      name: selectedRole ? selectedRole.name : "",
      role_id: value,
    });
  };

  const validateForm = () => {
    if (!formData.name) {
      setError("Role name is required.");
      return false;
    }
    return true;
  };


  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      const payload = { name: formData.name };
      if (mode === "edit" || mode === "create") {
        await onSubmit(providerData?.id, payload);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
      setFormData({ name: "", role_id: "" });
        } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "400px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2>
          {mode === "view"
            ? "View Role"
            : mode === "edit"
            ? "Edit Role"
            : mode === "create"
            ? "Create Role"
            : "Delete Role"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {mode === "view" && (
          <div>
            <p>
              <strong>Role Name:</strong> {providerData?.name || "N/A"}
            </p>
          </div>
        )}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Role Name:</label>
              <select
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
                className={classes.enroleeInputId}
                style={{ width: "100%", padding: "8px", marginTop: "8px" }}
                required
              >
                <option value="">Select a role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>
            Are you sure you want to delete the role "{providerData?.name}"?
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "view" ? "Close" : "Cancel"}
          </button>
          {(mode === "edit" || mode === "create" || mode === "delete") && (
            <button
              onClick={handleSubmit}
              style={{
                padding: "8px 16px",
                background: mode === "delete" ? "#d32f2f" : "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {mode === "edit"
                ? "Save"
                : mode === "create"
                ? "Create"
                : "Delete"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReusableRoleModal;